import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
} from 'react'
import { computeTagPromoOff } from './promotion/tagPromoOff'

type TagPromoOffContextType = {
  withTagPromoOff: (
    tags: string[],
    price: number,
    compare_at_price: number
  ) => {
    price: number
    compare_at_price: number
    isPromoOff: boolean
    isOnSale: boolean
  }
}

const TagPromoOffContext = createContext<TagPromoOffContextType>({
  withTagPromoOff: (_, price, compare_at_price) => ({
    price,
    compare_at_price,
    isPromoOff: false,
    isOnSale: !!compare_at_price && compare_at_price > price,
  }),
})

export const TagPromoOffProvider = ({
  children,
  config,
}: PropsWithChildren<{ config: any }>) => {
  const withTagPromoOff = useCallback(
    (tags: string[], price: number, compare_at_price: number) =>
      computeTagPromoOff(config, tags, price, compare_at_price),
    [config]
  )

  return (
    <TagPromoOffContext.Provider value={{ withTagPromoOff }}>
      {children}
    </TagPromoOffContext.Provider>
  )
}

export const useTagPromoOff = () => useContext(TagPromoOffContext)
